import { API_BASE_URL } from '../config/env';

async function parseJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = data?.error || data?.message || `Error ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

export async function fetchApiKeys() {
  const res = await fetch(`${API_BASE_URL}/api/admin/api-keys`, {
    credentials: 'include'
  });
  return parseJson(res);
}

export async function createApiKey(name, expiresInDays = 90) {
  const res = await fetch(`${API_BASE_URL}/api/admin/api-keys`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name,
      expires_in_days: expiresInDays
    })
  });
  return parseJson(res);
}

export async function revokeApiKey(id) {
  const res = await fetch(`${API_BASE_URL}/api/admin/api-keys/${encodeURIComponent(id)}/revoke`, {
    method: 'POST',
    credentials: 'include'
  });
  return parseJson(res);
}

export async function deleteApiKey(id) {
  const res = await fetch(`${API_BASE_URL}/api/admin/api-keys/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    credentials: 'include'
  });
  return parseJson(res);
}
